import { render, staticRenderFns } from "./BatteryIndicator.vue?vue&type=template&id=5b86baf4"
import script from "./BatteryIndicator.vue?vue&type=script&lang=js"
export * from "./BatteryIndicator.vue?vue&type=script&lang=js"
import style0 from "./BatteryIndicator.vue?vue&type=style&index=0&id=5b86baf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports